import {http} from '../utils'

const alarmSave = params => {
  const url = `/task/mail/alarm/save`
  return http.post(url, params)
}

const getAlarm = () => {
  const url = `/task/mail/alarm/get`
  return http.post(url, {})
}

export default {
  alarmSave,
  getAlarm
}
